import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "/imports/state/AuthContext";
import { useWidget } from "/imports/state/WidgetContext";
import LoadingSpinner from "./LoadingSpinner";

function ProtectedRoute() {
  const { isAuthenticated, loading } = useAuth();
  const { slug } = useWidget();
  const location = useLocation();
  // The query matters as much as the path — a booking reminder links to
  // dashboard?tab=bookings, and dropping the search lands the client on the
  // Overview tab after signing in instead of the booking they came to see.
  const page = `${location.pathname.split("/").filter(Boolean).pop()}${location.search}`;

  // On a hard navigation the mount-time token check is still in flight here;
  // redirecting before it settles bounced logged-in users to the login page.
  // Hold the route until auth state is known.
  if (loading) {
    return <LoadingSpinner fullPage />;
  }

  if (!isAuthenticated) {
    return <Navigate to={`/${slug}/login?redirect=${encodeURIComponent(page)}`} replace />;
  }
  return <Outlet />;
}

export default ProtectedRoute;
